import { useEffect, useState } from "react";
import TonalStatistic from "../components/TonalStatistic";
import { useNavigate } from "react-router-dom";
import NumberOfMentions from "../components/NumberOfMentions";
import PostsThread from "../components/PostsThread";
import { useSelector } from "react-redux";
import { getReferences, getThread, getThreads } from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";
import { setThread } from "../redux/actions";
import { referencesService, summaryService } from "../api";
import { Skeleton } from "antd";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";

const Factory = () => {
  const thread = useSelector(getThread);
  const dispatch = useAppDispatch();
  const threads = useSelector(getThreads);
  const [loadingPost, setLoadingPost] = useState(true);
  const nowDate = new Date().toJSON().split("T")[0];
  const [regionData, setRegionData] = useState<any>([]);
  const references = useSelector(getReferences);
  //const feedStatistics = useSelector(getFeedStatistics)
  const [postCount, setPostCount] = useState({
    fb: 0,
    gs: 0,
    ig: 0,
    tg: 0,
    total: 0,
    tw: 0,
    vk: 0,
    yt: 0,
    dz: 0,
    ok: 0,
  });
  const currentFeedFilter = useSelector(getFeedFilter);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (thread)
      summaryService
        .getPostCountLight({
          thread_id: thread?.id,
          from: currentFeedFilter.from,
          to: currentFeedFilter.to,
          filter: {
            repostoption: "whatever",
            trustoption: currentFeedFilter.tonal,
            network_id:
              currentFeedFilter.networks.length > 0
                ? currentFeedFilter.networks
                : currentFeedFilter.network_id,
          },
        })
        .then((resp) => {
          setIsLoading(false);
          setPostCount(resp);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [thread, currentFeedFilter]);

  let minusFilter = 0;

  if (currentFeedFilter) {
    if (currentFeedFilter.networks.indexOf(1) == -1)
      minusFilter = minusFilter + postCount.vk;

    if (currentFeedFilter.networks.indexOf(2) == -1)
      minusFilter = minusFilter + postCount.tw;

    minusFilter = minusFilter + postCount.fb;
    minusFilter = minusFilter + postCount.ig;
    //minusFilter = minusFilter + postCount.ok

    if (currentFeedFilter.networks.indexOf(4) == -1)
      minusFilter = minusFilter + postCount.gs;

    if (currentFeedFilter.networks.indexOf(5) == -1)
      minusFilter = minusFilter + postCount.tg;

    if (currentFeedFilter.networks.indexOf(11) == -1)
      minusFilter = minusFilter + postCount.dz;

    if (currentFeedFilter.networks.indexOf(8) == -1)
      minusFilter = minusFilter + postCount.yt;

    if (currentFeedFilter.networks.indexOf(10) == -1)
      minusFilter = minusFilter + postCount.ok;
  }

  const totalScore = postCount.total - minusFilter;

  useEffect(() => {
    let params = {
      thread_id: +window.location.pathname.split("/")[2],
      date_from: nowDate + " 00:00:00",
      date_to: nowDate + " 23:59:59",
    };

    referencesService
      .loadRegions(params)
      .then((list: any) => {
        setRegionData([list?.failures, list?.errors]);
        setLoadingPost(false);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    dispatch(
      setThread(
        threads.find(
          (item: any) => item.id == window.location.pathname.split("/")[2]
        )
      )
    );
  }, [threads]);

  return (
    <div className="App">
      {loadingPost ? (
        <>
          <Skeleton
            active
            avatar
            loading={loadingPost}
            paragraph={{ rows: 4 }}
          />
        </>
      ) : (
        <>
          <div className="grid2 white-block">
            <div className="grid-block  btn-cursor grid1_3">
              <img
                src={`/coats/${window.location.pathname.split("/")[2]}.webp`}
                alt=""
              />
              <div>
                <p className="title-small">{thread?.threadname}</p>
                {regionData[1].data.reduce(
                  (acc: number, cur: number) => acc + cur,
                  0
                ) < 200 ? (
                  <p className="green">
                    <b>Умеренный фон</b>
                  </p>
                ) : (
                  <p className="red">
                    <b>Проблемы с доступом</b>
                  </p>
                )}
                <p>
                  Отключений за последний час:{" "}
                  <b>
                    {regionData[0].data
                      .slice(-2)
                      .reduce((acc: number, cur: number) => acc + cur / 96, 0)
                      .toFixed(2)}
                  </b>
                  %
                </p>
                <p>
                  Отключений за последние сутки:{" "}
                  <b>
                    {regionData[0].data
                      .reduce((acc: number, cur: number) => acc + cur / 96, 0)
                      .toFixed(2)}
                  </b>
                  %
                </p>
                <p>
                  Сообщений за последние сутки:{" "}
                  <b>
                    {regionData[1].data.reduce(
                      (acc: number, cur: number) => acc + cur,
                      0
                    )}
                  </b>
                </p>
                <p>
                  Количество комментариев по отключениям: <b>{totalScore}</b>
                </p>
              </div>
            </div>
            <div>
              {regionData.length > 1 && <NumberOfMentions data={regionData} />}
            </div>
          </div>
        </>
      )}
      <TonalStatistic />
      <PostsThread />
    </div>
  );
};

export default Factory;
